<template>
  <div class="outer screen text-center vh-100">
    <div class="p-4" style="width: 100%">
      <div v-if="!hasFirstName && !hasLastName">
        <PersonalDataScreen />
      </div>
      <!-- <div v-if="hasLastName && !hasJobposition">
        <WorkDataScreen />
      </div>
      <div v-if="hasJobposition && !hasEmail">
        <CommunicationDataScreen />
      </div> -->
      <div v-if="hasEmail && !hasQuestionGdpr">
        <QuestionGdprScreen />
      </div>
      <div v-if="hasQuestionGdpr && hasSavedData">
        <CodeScreen />
      </div>
      <div class="bottom-spacer"></div>
    </div>
  </div>
</template>

<script>
import PersonalDataScreen from "@/components/PersonalDataScreen.vue";
// import WorkDataScreen from "@/components/WorkDataScreen.vue";
// import CommunicationDataScreen from "@/components/CommunicationDataScreen.vue";
import QuestionGdprScreen from "@/components/QuestionGdprScreen.vue";
import CodeScreen from "@/components/CodeScreen.vue";

export default {
  name: "HomeView",
  components: {
    PersonalDataScreen,
    // WorkDataScreen,
    // CommunicationDataScreen,
    QuestionGdprScreen,
    CodeScreen,
  },
  computed: {
    hasFirstName: function () {
      if (this.$store.getters.getFirstName === "") {
        return false;
      }
      return true;
    },
    hasLastName: function () {
      if (this.$store.getters.getLastName === "") {
        return false;
      }
      return true;
    },
    hasEmail: function () {
      if (this.$store.getters.getEmail === "") {
        return false;
      }
      return true;
    },
    hasJobposition: function () {
      if (this.$store.getters.getJobposition === "") {
        return false;
      }
      return true;
    },

    hasQuestionGdpr: function () {
      if (this.$store.getters.getQuestionGdpr === null) {
        return false;
      }
      return true;
    },
    hasSavedData: function () {
      if (this.$store.getters.getSavedData === null) {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
/* .background {
  width: 100%;
  height: 100vh;
  background-color: #ffebfa;
  background-image: url("@/assets/background.jpg");
  background-size: cover;
} */

.screen {
  /* background: url("~@/assets/logo.png") no-repeat center center fixed; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  overflow: hidden; /* Hide scrollbars */
  background-color: #ffebfa;
  color: #000 !important;
  /* text-transform: uppercase; */
  background-image: url("@/assets/background.jpg");
  background-size: cover;
}

.logo {
  padding: 15px;
}
.bottom-spacer {
  padding: 100px;
}
* {
  border-radius: 1 !important;
}
</style>
